<template>
    <div>
        <v-toolbar flat color="white">
            <h1 class="page-title-table">{{ name }}</h1>
            <v-spacer/>
            <v-spacer/>
            <v-text-field v-model="searchText" label="Pesquisar" class="mx-4 mt-10"/>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <div>
                        <v-btn v-on="on" class="mt-4" color="primary"
                            @click="novo" v-if="isIncluir">
                            <v-icon dark>add</v-icon>
                            Adicionar
                        </v-btn>
                    </div>
                </template>
                <span>Cadastrar</span>
            </v-tooltip>
        </v-toolbar>
    </div>
</template>

<script>

import _ from "lodash";

export default {

    props: {
        name: String,
        search: Function,
        novo: Function,
        isIncluir: Boolean
    },

    name: "TableSearch",

    data() {
        return {
            searchText: ""
        }
    },

    watch: {
        searchText: _.debounce(function () {
            this.search(this.searchText);
        }, 300),
    },
}
</script>
